import { PropsWithChildren } from 'react';
import { theme } from '@frontend/theme';
import { Accordion, Dot, Text } from '@frontend/design-system';

type ItemProps = PropsWithChildren<{
  value: string;
}>;

const Item = ({ value, children, ...rest }: ItemProps) => {
  return (
    <Accordion.Item value={value} {...rest}>
      {children}
    </Accordion.Item>
  );
};

type HeaderProps = {
  label?: string;
  hasFilters?: boolean;
};

const Header = ({ hasFilters = false, label }: HeaderProps) => {
  return (
    <Accordion.Header>
      <Text
        weight='bold'
        css={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(1),
        }}
      >
        {label}{' '}
        {hasFilters && (
          <Dot
            color='primary'
            css={{
              position: 'static',
            }}
          />
        )}
      </Text>
    </Accordion.Header>
  );
};

const Body = ({ children, ...rest }: PropsWithChildren) => {
  return (
    <Accordion.Body
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        padding: theme.spacing(2, 3),
      }}
      {...rest}
    >
      {children}
    </Accordion.Body>
  );
};

export const FilterAccordion = { Item, Body, Header };
